/**
 * PDP CTA click tracking — separate GA4 events for:
 *   - pdp_atc_click      (Add to Cart / sticky ATC)
 *   - pdp_buy_now_click  (Shop Pay / dynamic checkout / Buy It Now)
 *
 * Fires via gtag (→ GA4 → BigQuery) and Shopify.analytics.publish as backup.
 */
(function () {
  if (window.__hsPdpCtaTrackBound) return;
  window.__hsPdpCtaTrackBound = true;

  function readCtx() {
    var el = document.querySelector('[data-hs-pdp-cta-track]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  var ctx = readCtx();

  function currentVariantId() {
    var input =
      document.querySelector('product-form form [name="id"]') ||
      document.querySelector('.product-form form [name="id"]') ||
      document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return String(input.value);
    return ctx.variant_id ? String(ctx.variant_id) : '';
  }

  function buildParams(extra) {
    var params = {
      product_id: ctx.product_id || '',
      product_handle: ctx.product_handle || '',
      product_title: ctx.product_title || '',
      variant_id: currentVariantId(),
      page_location: window.location.href,
    };
    if (extra) {
      for (var k in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, k)) params[k] = extra[k];
      }
    }
    return params;
  }

  function fire(eventName, extra) {
    var params = buildParams(extra);

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, params));
    } catch (e) {}

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params);
      }
    } catch (e) {}

    try {
      if (
        window.Shopify &&
        Shopify.analytics &&
        typeof Shopify.analytics.publish === 'function'
      ) {
        Shopify.analytics.publish(eventName, params);
      }
    } catch (e) {}
  }

  function isDisabled(el) {
    if (!el) return true;
    if (el.disabled || el.getAttribute('aria-disabled') === 'true') return true;
    if (el.hasAttribute('disabled')) return true;
    return false;
  }

  function findAtcButton(target) {
    if (!target || !target.closest) return null;

    /* Sticky bar forwards to the real form button via .click() — count that one only. */
    var submit = target.closest(
      'product-form button[name="add"], .product-form__submit[name="add"], button.product-form__submit'
    );
    if (submit) {
      /* Only count main PDP form — skip collection quick-add cards */
      if (submit.closest('product-form') || submit.closest('.product-form__buttons')) {
        return { el: submit, source: 'form' };
      }
    }
    return null;
  }

  function findBuyNowButton(target) {
    if (!target || !target.closest) return null;

    var buyItNow = target.closest('[data-hs-buy-now]');
    if (buyItNow) return { el: buyItNow, type: 'buy_it_now' };

    var moreOpts = target.closest('.shopify-payment-button__more-options');
    if (moreOpts) return { el: moreOpts, type: 'more_payment_options' };

    var paymentBtn = target.closest(
      '.shopify-payment-button__button, .shopify-payment-button [role="button"], [data-testid="ShopifyPay-button"], shopify-accelerated-checkout, shopify-accelerated-checkout-cart'
    );
    if (paymentBtn) {
      var type = 'payment_button';
      var cls = (paymentBtn.className && String(paymentBtn.className)) || '';
      var label = (paymentBtn.textContent || '').toLowerCase();
      if (
        cls.indexOf('branded') !== -1 ||
        label.indexOf('shop') !== -1 ||
        paymentBtn.closest('[data-testid="ShopifyPay-button"]') ||
        paymentBtn.tagName === 'SHOPIFY-ACCELERATED-CHECKOUT' ||
        paymentBtn.tagName === 'SHOPIFY-ACCELERATED-CHECKOUT-CART'
      ) {
        type = 'shop_pay';
      }
      return { el: paymentBtn, type: type };
    }

    /* Fallback: any click inside payment button wrapper that looks interactive */
    var wrap = target.closest('.shopify-payment-button');
    if (wrap && !target.closest('[data-hs-buy-now-wrap]')) {
      var interactive = target.closest('button, [role="button"], a, shopify-pay-button');
      if (interactive) return { el: interactive, type: 'shop_pay' };
    }

    return null;
  }

  function pickFromPath(path, finder) {
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node || node.nodeType !== 1) continue;
      var hit = finder(node);
      if (hit) return hit;
    }
    return null;
  }

  /* Capture phase so we still see the click even if handlers call stopPropagation.
     composedPath covers Shop Pay / accelerated-checkout shadow DOM. */
  document.addEventListener(
    'click',
    function (e) {
      var path = typeof e.composedPath === 'function' ? e.composedPath() : [];
      if (!path.length) {
        var t = e.target;
        if (t && t.nodeType === 3) t = t.parentElement;
        path = t ? [t] : [];
      }

      var atc = pickFromPath(path, function (node) {
        return findAtcButton(node);
      });
      if (atc && !isDisabled(atc.el)) {
        fire('pdp_atc_click', { cta_source: atc.source });
        return;
      }

      var buy = pickFromPath(path, function (node) {
        return findBuyNowButton(node);
      });
      if (buy && !isDisabled(buy.el)) {
        fire('pdp_buy_now_click', {
          cta_source: 'form',
          buy_now_type: buy.type,
        });
      }
    },
    true
  );
})();
